var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmojiMakerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 292.5 244.3",
    enableBackground: "new 0 0 292.5 244.3",
    xmlSpace: "preserve",
    style: {
      paddingTop: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.4,242.2c-19.3-5.8-34.1-21.4-44.4-37.8c-57.7,2.9-129.7-10.6-163-44.4c-14.7-13.8-16.8-21.3-7.2-27 c3.9-2.7,7.5-0.9,18.3,9c61.1,56.6,183.8,55.5,241.6,2.4c23.3-24.9,35.4-6.9,19.8,10.5c0,0-8.1,8.7-8.1,8.7 c3.3,9.4,9.8,28.2,9.6,36C285.4,233.2,250.1,250.4,220.4,242.2z M253.7,219.5c15.3-6.1,14.5-25.5,8.1-36c-3.9-5.4-4.5-5.4-21.6,2.1 c-9.9,4.2-22.8,9.3-28.8,11.4c-12.9,3.9-13.8,6-6,12.9C220.4,223.7,238.7,227.3,253.7,219.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M222.2,72.6c-38.4-20.4-44.4-25.2-41.7-32.1C183,34.3,258.2-2,264.2,0.1c10.2,10.6,5.2,15.7-15.3,25.8 c-39,18.9-38.7,16.8-7.2,33.6C264.2,71.7,269,75.6,269,81.3C263.1,103.9,251,85.2,222.2,72.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M50.2,83.7c-54.5-29-5.8-109.3,45-73.7C137.1,41.1,95.6,108.4,50.2,83.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmojiMakerIcon);
export default __webpack_public_path__ + "static/media/emoji_maker_icon.33c91f7c.svg";
export { ForwardRef as ReactComponent };